import units from '@exodus/fiat-currencies';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import type { Asset } from '@/types';
import selectors from '@/ui/flux/selectors';

function useFiatAsset() {
  const currencyName = useSelector<unknown, string>(selectors.locale.currency);

  return useMemo(() => {
    const currency = units[currencyName];

    return {
      currency,
      name: currencyName,
      displayName: currency.label,
      displayTicker: currency.symbol,
    } as unknown as Asset;
  }, [currencyName]);
}

export default useFiatAsset;
